// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__197RP","form-field":"Form_form-field__21Qw_","checkbox":"Form_checkbox__3Oxtn"};